import { getOr } from 'lodash/fp';

export default (state, { designId, pricingResult }) => ({
  ...state || {},
  designs: {
    ...getOr({}, 'designs')(state),
    [designId]: {
      ...getOr({}, `designs.${designId}`)(state),
      pricingResult,
    },
  },
});
